import { contactForm, invitationCreate, notificationEmail, updateAvatar, userDelete, userUpdate, userPreferences } from "../../routes/api/paths";
import { handleResponse, requestOptions, requestOptionsFile } from "../HandlerService";

export const UpdateAvatarService = async (data) => {
  const { token, file } = data;
  const options = requestOptionsFile('POST', file, token);
  return fetch(updateAvatar, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const UpdateUserService = async (data) => {
  const { token, userData } = data;
  const options = requestOptions('PUT', userData, token);
  return fetch(userUpdate, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error}));
}

export const DeleteUserService = async (data) => {
  const { token, id } = data;
  const options = requestOptions('DELETE', { id: [id] }, token);
  return fetch(userDelete, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const GetInvitationService = async (data) => {
  const { token } = data;
  const options = requestOptions('POST', {}, token);
  return fetch(invitationCreate, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const ContactFormService = async (data) => {
  const options = requestOptions('POST', data);
  return fetch(contactForm, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const GetUserPreferencesService = async ({ token }) => {
  const options = requestOptions('GET', {}, token);
  return fetch(userPreferences, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const UpdateUserPreferencesService = async ({ token, preferences }) => {
  const options = requestOptions('PUT', preferences, token);
  return fetch(userPreferences, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const UpdateEmailNotificationService = async ({ token, type, status }) => {
  const options = requestOptions('GET', {}, token);
  return fetch(notificationEmail(type, status), options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}
